import withRsSlidableNavigationHandlers from '@Pages/RetroSynthesis/components/RsSlidable/HOCs/withSlidableNavigationHandlers';
import RsSlidableNavigationRightSideBase from './RsSlidableNavigationRightSideBase';

export default withRsSlidableNavigationHandlers()(RsSlidableNavigationRightSideBase);
